<div class="modal-body report-form LVCLS-joinclass-report-popup">
  <h4>{{reportAnIssueTitle}}</h4>
  <ng-container *ngFor="let item of reportAnIssueQuestion; index as i">
    <p class="LVCLS-pop-heading">{{item.title}}</p>
    <div class="checklist">
      <div class="custom-control custom-checkbox" *ngFor="let itemOpt of item.options; index as k">
        <input type="checkbox" class="custom-control-input" id="customCheck{{i}}-{{k}}" [checked]="itemOpt.selected"
          (click)="updateFormValue(i, itemOpt.key)">
        <label class="custom-control-label" for="customCheck{{i}}-{{k}}">{{itemOpt.label}}</label>
      </div>
    </div>
  </ng-container>
  <!-- <p>1. Audio and Video</p>
  <div class="mb-4">
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck1-0">
      <label class="custom-control-label" for="customCheck1-0">Unable to see teacher's video</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck2-0">
      <label class="custom-control-label" for="customCheck2-0">Unable to hear teacher's audio</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck3-0">
      <label class="custom-control-label" for="customCheck3-0">Unable to maximize teacher's video</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck4-0">
      <label class="custom-control-label" for="customCheck4-0">Unable mute or unmute my audio</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck5-0">
      <label class="custom-control-label" for="customCheck5-0">Unable enable or disable my video</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck6-0" checked>
      <label class="custom-control-label" for="customCheck6-0">Unable to maximize teacher's video</label>
    </div>
  </div>
  <p>2. Content</p>
  <div class="mb-4">
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck1-1">
      <label class="custom-control-label" for="customCheck1-1">Unable to see content shared by teacher</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck2-1">
      <label class="custom-control-label" for="customCheck2-1">Unable to maximize content shared by teacher</label>
    </div>
  </div>
  <p>3. Chats</p>
  <div class="mb-4">
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck1-2">
      <label class="custom-control-label" for="customCheck1-2">Unable to see chat messages</label>
    </div>
    <div class="custom-control custom-checkbox mb-2">
      <input type="checkbox" class="custom-control-input" id="customCheck2-2">
      <label class="custom-control-label" for="customCheck2-2">Unable to send chat messages</label>
    </div>
  </div> -->
  <div
    class="d-flex justify-content-md-start justify-content-sm-center flex-sm-row flex-column border-top pt-4 align-self-center mt-3">
    <button class="btn btn-primary btn-blue mb-0" type="button" [disabled]="isSubmitDisabled"
      (click)="submitReportAnIssueForm()">Submit</button>
    <button type="button" class="btn-link border-top-0 ml-md-3 _mt-3 skip-btn" (click)="skipReportAnIssue()"
      [disabled]="isSkipDisabled">SKIP</button>
  </div>
</div>
